module.exports = __webpack_public_path__ + "img/overview-notification-symbol.1ff4156a.svg";